const ENGAGE_NAMESPACES = ["/engage", "/mobile/engage"] as const;

export default ENGAGE_NAMESPACES;
